import { render, staticRenderFns } from "./PivotVxeTable.vue?vue&type=template&id=66472283&scoped=true&"
import script from "./PivotVxeTable.vue?vue&type=script&lang=js&"
export * from "./PivotVxeTable.vue?vue&type=script&lang=js&"
import style0 from "./PivotVxeTable.vue?vue&type=style&index=0&id=66472283&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66472283",
  null
  
)

export default component.exports